import { useState, useEffect } from 'react';
import TopNavigationDesktop from './TopNavigationDesktop';
import TopNavigationMobile from './TopNavigationMobile';

export default function TopNavigation(props) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <TopNavigationMobile {...props} /> : <TopNavigationDesktop {...props} />;
}

